"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_STYLES = exports.DEFAULT_DEVICE_TYPE = void 0;
var DEFAULT_STYLES = {
  SECTION_TILE_GROUP: {
    MIN_HEIGHT: '68px',
    BORDER_COLOR: 'darkGreen',
    NO_OF_COLUMNS: '2',
    ACTIVE_TITLE_COLOR: 'default',
    TITLE_TYPE: 'sub',
    ACTIVE_BG_COLOR: 'darkGreen'
  },
  HEADING: {
    MARGIN_BOTTOM: 'small',
    TYPE: 'h3'
  },
  INSTRUCTION: {
    TYPE: 'small',
    MARGIN_BOTTOM: 'small'
  },
  EXPANDER: {
    ICON: 'CloseIcon'
  }
};
exports.DEFAULT_STYLES = DEFAULT_STYLES;
var DEFAULT_DEVICE_TYPE = 'mobile';
exports.DEFAULT_DEVICE_TYPE = DEFAULT_DEVICE_TYPE;